import UseAxios from '../http/http';
import { serviceName } from '../resources/serviceConstants';
import {
  TIME_SHEET_REPORT_DELETE_EFFORT_URL,
  TIME_SHEET_REPORT_UPDATE_EFFORT_URL,
  TIME_SHEET_REPORT_BULK_ADD_EFFORTS_URL,
  TIME_SHEET_REPORT_GET_ACTIVITIES_OPTION_URL,
  TIME_SHEET_REPORT_GET_PROJECT_NAME_OPTION_URL,
  TIME_SHEET_REPORT_ALREADY_LOGGED_EFFORTS,
  TIME_SHEET_REPORT_GET_EFFORT_LOGGING_DATES_URL,
} from '../resources/endPoint';


const getAuthHeaders = (token) => ({
  'Content-Type': 'application/json',
  token: token || '',
  isAuthToken: true,
});

export const fetchAlreadyLoggedEfforts = ({ authToken, employeeId, startDate, endDate,
  setLoading, userInfo, tableViewType }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'post',
  url: TIME_SHEET_REPORT_ALREADY_LOGGED_EFFORTS,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload: {
    employeeId: employeeId || '',
    startDate,
    endDate,
    userInfo,
    tableViewType,
  },
}, setLoading);

export const fetchProjectOptions = ({ authToken, employeeId, userInfo }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'post',
  url: TIME_SHEET_REPORT_GET_PROJECT_NAME_OPTION_URL,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload: {
    employeeId: employeeId || '',
    userInfo,
  },
});

export const fetchActivityOptions = ({ authToken, employeeId, userInfo }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'post',
  url: TIME_SHEET_REPORT_GET_ACTIVITIES_OPTION_URL,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload: {
    employeeId: employeeId || '',
    userInfo,
  },
});

export const bulkAddEfforts = ({ authToken, employeeId, effortsData, userInfo, tableViewType }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'post',
  url: TIME_SHEET_REPORT_BULK_ADD_EFFORTS_URL,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload: {
    effortsData,
    employeeId: employeeId || '',
    userInfo,
    tableViewType: tableViewType || 'list_view',
  },
});

export const updateLoggedEffort = ({ authToken, timeSheetId, effortData, userInfo, tableViewType }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'post',
  url: TIME_SHEET_REPORT_UPDATE_EFFORT_URL,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload: {
    timeSheetId,
    effortData,
    userInfo,
    tableViewType: tableViewType || '',
  },
});

export const deleteLoggedEffort = ({ authToken, employeeId, timeSheetId, userInfo, tableViewType }) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'delete',
  url: `${TIME_SHEET_REPORT_DELETE_EFFORT_URL}/${timeSheetId}`,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
  payload: {
    employeeId: employeeId || '',
    userInfo,
    tableViewType: tableViewType || '',
  },
});

export const getEffortLoggingDates = ({ authToken}) => UseAxios({
  service: serviceName.PROJECT_MS,
  method: 'get',
  url: TIME_SHEET_REPORT_GET_EFFORT_LOGGING_DATES_URL,
  headers: getAuthHeaders(authToken),
  authRequired: true,
  csrfToken: true,
});

